import type { FlexProps } from "@qws-org/ui-kit";
import { Flex } from "@qws-org/ui-kit";
import type { FC } from "react";
import React from "react";

import type {
  Action,
  Maybe,
  Pages,
  WelcomeOfferBannerWelcomeOfferBannerItems,
} from "~/core";
import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { WelcomeOfferCard } from "~/features/welcome-offer-banner/components/WelcomeOfferCard";

export type WelcomeOfferCardsProps = {
  data: Array<Maybe<WelcomeOfferBannerWelcomeOfferBannerItems>> | undefined;
  isActionInactive: (action: Action) => boolean;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  className?: string;
} & FlexProps;

export const WelcomeOfferCards: FC<WelcomeOfferCardsProps> = ({
  data,
  isActionInactive,
  getUrl,
  onCallAction,
  className,
  ...rest
}) => {
  return (
    <Flex
      className={`flex-grow md:flex-grow-0 ${className} `}
      flexDirection="column"
      align="center"
      justify="center"
      m={{ mb: 16 }}
      p={{ px: 24 }}
      gap="16px"
      {...rest}
      width="100%"
      md={{ width: "auto", p: 0, ...rest.md }}
      d={{ m: { mt: 14 }, ...rest.d }}
    >
      {data
        ?.filter((card) => {
          if (card?.welcome_offer_banner_items_id?.action) {
            return !isActionInactive(card.welcome_offer_banner_items_id.action);
          }

          return true;
        })
        ?.map((card) => {
          if (!card?.welcome_offer_banner_items_id) return null;
          const controlAction = card.welcome_offer_banner_items_id.action;
          const action = controlAction?.action?.[0];
          let href;

          if (isExternalLink(action?.item)) {
            href = action.item.href ?? undefined;
          }

          if (isInternalLink(action?.item)) {
            href = action.item.page ? getUrl(action.item.page) : undefined;
          }

          return (
            <WelcomeOfferCard
              href={href}
              key={card.id}
              card={card.welcome_offer_banner_items_id}
              onPress={() => {
                if (action) {
                  onCallAction(controlAction);
                }
              }}
            />
          );
        })}
    </Flex>
  );
};
